import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import {
  IItemCreationSubsectionInputProps,
  ItemCreationSubsection,
  TextEditor,
} from '~/Components';
import { ProductCardsColorful } from '~/Components/Icons';
import { makeStyles } from '~/UIKit/Style';
import { ExtendedLocation } from '../ExtendedLocation.model';
import { LocationEditCustomImageUploader } from './LocationEditCustomElements';
import { BORDER_COLOR } from '~/Constants/Colors.constants';

const useStyles = makeStyles((theme) => ({
  [theme.breakpoints.up('md')]: {
    container: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  noteInput: {
    border: `1px solid ${BORDER_COLOR}`,
  },
}));

export const LocationEditDetailSection = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const LocationImageDetails: IItemCreationSubsectionInputProps<Partial<ExtendedLocation>>[] = [
    {
      customElement: <LocationEditCustomImageUploader />,
      customElementFullSection: true,
    },
  ];

  const LocationDescriptionDetails: IItemCreationSubsectionInputProps<
    Partial<ExtendedLocation>
  >[] = [
    {
      customElement: (
        <TextEditor
          title={`${t('form.field.location.description')}*`}
          fieldName="description"
          noMarkup
          tooltip={{
            title: t('form.field.location.description.hint'),
            icon: <ProductCardsColorful />,
            placement: isMobile ? 'auto' : 'auto-start',
          }}
          className={classes.noteInput}
        />
      ),
      customElementFullSection: true,
    },
  ];

  const LocationImportantInformationDetails: IItemCreationSubsectionInputProps<
    Partial<ExtendedLocation>
  >[] = [
    {
      customElement: (
        <TextEditor
          title={`${t('form.field.location.importantInfo')}*`}
          fieldName="importantInformation"
          noMarkup
          tooltip={{
            title: t('form.field.location.importantInfo.hint'),
            icon: <ProductCardsColorful />,
            placement: isMobile ? 'auto' : 'auto-start',
          }}
          className={classes.noteInput}
        />
      ),
      customElementFullSection: true,
    },
  ];

  return (
    <div className={classes.container}>
      <ItemCreationSubsection items={LocationImageDetails} />
      <ItemCreationSubsection items={LocationDescriptionDetails} />
      <ItemCreationSubsection items={LocationImportantInformationDetails} />
    </div>
  );
};
